import MuiList from "@mui/material/List";
const List = MuiList;
export default List;
